export class DialogCloseData {
    operationName: string;
    data: any;
    constructor(operationName, data) {
        this.operationName = operationName;
        this.data = data;
    }
}
